import React from 'react';
import { Search, MousePointerClick, PenTool, Settings, MapPin, BarChart3 } from 'lucide-react';
const services = [{
  icon: Search,
  title: 'SEO Services',
  description: 'Dominate organic search results with our proven ranking strategies tailored for the UK market.'
}, {
  icon: MousePointerClick,
  title: 'PPC Management',
  description: 'Maximize ROI with precision-targeted Google Ads and social media paid campaigns.'
}, {
  icon: PenTool,
  title: 'Content Marketing',
  description: 'Engage your audience with high-quality, SEO-optimized content that converts visitors.'
}, {
  icon: Settings,
  title: 'Technical SEO',
  description: 'Optimize your site structure, speed, and crawlability for better search engine performance.'
}, {
  icon: MapPin,
  title: 'Local SEO',
  description: 'Capture local customers in your area. Perfect for UK businesses targeting specific regions.'
}, {
  icon: BarChart3,
  title: 'Analytics & Reporting',
  description: 'Transparent, real-time reporting so you always know exactly where your budget is going.'
}];
export function Services() {
  return <section id="services" className="py-24 bg-white" data-id="element-158">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-159">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-160">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-161">
            Comprehensive Digital Growth Solutions
          </h2>
          <p className="text-lg text-slate-600" data-id="element-162">
            We don't just drive traffic; we drive revenue. Our integrated
            approach ensures every channel works together for maximum impact.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-163">
          {services.map((service, index) => <div key={index} className="group p-8 bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-xl hover:border-emerald-100 transition-all duration-300" data-id="element-164">
              <div className="w-14 h-14 bg-emerald-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-emerald-500 transition-colors duration-300" data-id="element-165">
                <service.icon className="w-7 h-7 text-emerald-600 group-hover:text-white transition-colors duration-300" data-id="element-166" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-emerald-600 transition-colors" data-id="element-167">
                {service.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-168">
                {service.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}